export default "__VITE_ASSET__B5oDrP7R__"